import { RadioGroup as RadioGroupPrimitive } from 'radix-ui';

import { Tag } from '@/components/ui/tag';
import { cn } from '@/lib/utils';

// Mirrors the radio styles of the ban-elevate RadioButton, which only exposes plain string labels.
const radioButtonStyles = cn([
  'size-20',
  'shrink-0',
  'rounded-round',
  'border',
  'border-emphasized',
  'bg-default',
  'cursor-pointer',
  'transition-colors',
  'hover:bg-subtle',
  'focus-visible:outline-2',
  'focus-visible:outline-offset-2',
  'focus-visible:outline-brand',
  'data-[state=checked]:border-brand',
  'data-[state=checked]:bg-brand',
  'data-[state=checked]:hover:border-brand-hover',
  'data-[state=checked]:hover:bg-brand-hover',
]);

type TagRadioGroupProps = {
  readonly options: readonly {
    readonly value: string;
    readonly label: string;
  }[];
  readonly value: string | undefined;
  readonly onValueChange: (value: string) => void;
};

/** Radio group whose options are rendered as outline tags, so they look identical to the read-only tags. */
export const TagRadioGroup = ({ options, value, onValueChange }: TagRadioGroupProps) => (
  <RadioGroupPrimitive.Root className="flex flex-col items-start gap-4" value={value} onValueChange={onValueChange}>
    {options.map((option) => (
      <label key={option.value} className="flex cursor-pointer items-center gap-8 select-none">
        <RadioGroupPrimitive.Item value={option.value} className={radioButtonStyles}>
          <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
            <span className="bg-default rounded-round size-12" />
          </RadioGroupPrimitive.Indicator>
        </RadioGroupPrimitive.Item>
        <Tag variant="outline" size="compact" label={option.label} />
      </label>
    ))}
  </RadioGroupPrimitive.Root>
);
